<template>
  <label class="selectgroup-item mb-0">
    <input
      v-model="radioButtonValue"
      type="radio"
      :value="label"
      :name="name"
      class="selectgroup-input"
      :class="[
        label,
        isChecked? 'checked':'',
      ]"
    >
    <span
      class="selectgroup-button selectgroup-button-icon"
    ><i
      class="fa far"
      :class="icon"
    /></span>
  </label>
</template>

<script>
export default {
  name: 'BaseRadio',
  props: {
    name: {
      type: String,
      default: 'options',
    },
    label: {
      type: String,
      default: '1',
    },
    icon: {
      type: String,
      default: 'fa-check',
    },
    val: {
      type: [String, Object],
      default: '',
    },
  },
  data() {
    return {
    //   isChecked: false,
    };
  },
  computed: {
    radioButtonValue: {
      get() {
        return this.val;
      },
      set() {
        this.$emit('change', this.label);
      },
    },
    isChecked() {
      return this.label === this.val;
    },
  },
};
</script>

<style lang="scss" scoped>
$gray-light: lighten($secondary, 15%);
$gray-lighter: lighten($secondary, 30%);

@mixin toggle-mixin($size: 1.5rem, $margin: 2rem, $font-size: 0.75rem) {
  margin: 0 $margin;
  padding: 0;
  position: relative;
  border: none;
  height: $size;
  width: $size * 2;
  border-radius: $size;
  color: $secondary;
  background: $gray-lighter;

  &:focus,
  &.focus {
    &,
    &.is-active {
      outline: none;
    }
  }

  &:before,
  &:after {
    color: $secondary;
    line-height: $size;
    width: $margin;
    text-align: center;
    font-weight: 600;
    font-size: $font-size;
    text-transform: uppercase;
    letter-spacing: 2px;
    position: absolute;
    bottom: 0;
    transition: opacity 0.25s;
  }
  &:before {
    content: "Off";
    left: -$margin;
  }
  &:after {
    content: "On";
    right: -$margin;
    opacity: 0.5;
  }

  > .handle {
    position: absolute;
    top: ($size * 0.25) / 2;
    left: ($size * 0.25) / 2;
    width: $size * 0.75;
    height: $size * 0.75;
    border-radius: $size * 0.75;
    background: #fff;
    transition: left 0.25s;
  }
  &.is-active {
    background-color: $primary;
    transition: background-color 0.25s;
    > .handle {
      left: $size + (($size * 0.25) / 2);
      transition: left 0.25s;
    }
    &:before {
      opacity: 0.5;
    }
    &:after {
      opacity: 1;
    }
  }
}

.btn-toggle {
  @include toggle-mixin;
}
</style>
